'use client';
import styled from 'styled-components';

const BestSellersStyle = styled.section`
	--distanceTitleContent: var(--sp9x);

	.title-button-wrapper {
		display: flex;
		justify-content: space-between;
		align-items: center;
		margin-bottom: var(--distanceTitleContent);
	}

	.wrapper-bestseller {
		display: grid;
		grid-template-columns: repeat(4, 1fr);
		gap: var(--gutter);
	}

	/* //! 1920 */
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.desktopSizeXLMin}) {
		--distanceTitleContent: var(--sp7x);
	}

	/* //! 1536 */
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.desktopSizeLMin}) {
		--distanceTitleContent: var(--sp6x);
	}

	/* //! 1366 */
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.desktopSizeMMin}) {
		--distanceTitleContent: var(--sp4x);
	}

	/* //! 1280 */
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.desktopSizeSMin}) {
	}

	/* //! 768 */
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.tabletSizeMin}) {
		.wrapper-bestseller {
			grid-template-columns: repeat(3, 1fr);
		}
	}

	/* //! Mobile */
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.tabletSizeSMin}) {
		.title-button-wrapper {
			display: flex;
			flex-direction: column;
			align-items: flex-start;
			gap: var(--distanceTitleContent);
		}

		.wrapper-bestseller {
			grid-template-columns: repeat(2, 1fr);
		}
	}
`;
export default BestSellersStyle;
